import * as React from 'react';
import Box from '@mui/material/Box';
import MuiCard from '@mui/material/Card';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import { useIdentityContext } from '../../../context/IdentityContext';
import { SubmitHandler, useForm } from "react-hook-form";
import Button from '@mui/material/Button';
import { FormGroup } from '@mui/material';
import { Badge, List, ListItem, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import { NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSquare, faSquareCheck } from '@fortawesome/pro-light-svg-icons';
import { useAppSelector } from "../../../redux/hooks";
import { getEndUserLicenseAgreement } from "../../../redux/Slices/company.slice";

const Card = styled(MuiCard)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignSelf: 'center',
  width: '100%',
  minHeight: '300px',
  padding: theme.spacing(4),
  gap: theme.spacing(2),
  boxShadow:
    'hsla(220, 30%, 5%, 0.05) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.05) 0px 15px 35px -5px',
  [theme.breakpoints.up('sm')]: {
    width: '450px',
  },
  ...theme.applyStyles('dark', {
    boxShadow:
      'hsla(220, 30%, 5%, 0.5) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.08) 0px 15px 35px -5px',
  }),
}));

interface SignupStep0Props {
  onNextClick: () => void;
}

export const SignupStep0 : React.FC<SignupStep0Props> = (props) => {

  const { authenticatedUser } = useIdentityContext();
  const { control, handleSubmit } = useForm<{ companyName: string }>();
  const endUserLicenseAgreement = useAppSelector(getEndUserLicenseAgreement);

  const onSubmit: SubmitHandler<{}> = () => {
    props.onNextClick();
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} style={{ width: "100%" }}>
      <Card variant="outlined">
        <Box sx={{ display: { xs: 'flex' } }}>
          <img src="/logo.png" alt="Logo" style={{ height: 40, paddingBottom:0 }} />  
        </Box>

        <Typography
          component="h1"
          variant="h4"
          sx={{ width: '100%', fontSize: 'clamp(2rem, 10vw, 2.15rem)' }}
        >
          Welcome {authenticatedUser.fullName} 
        </Typography>

        <Typography
          sx={{ width: '100%', fontSize: 'clamp(2rem, 10vw, 2.15rem)' }}
        >
        It looks like your company has not previously signed up for use in our portal so thank you for choosing us and welcome!   
        </Typography>

        <Typography
          sx={{ width: '100%', fontSize: 'clamp(2rem, 10vw, 2.15rem)' }}
        >
        As mentioned previously, we will be 
        validating a connection to your Sentinel instance.  In order to do this, a process by our engineers is necessary for setup.  
        Please have your Subscription id ready before progressing.
        </Typography>
        
      <List>
        {/* USER AGREEMENT LINK */}
        <ListItem
          key={"endUserLicenseAgreement"}
          disablePadding
          sx={{ display: "block" }}
        >
          <NavLink
            to={"/eula"}
            title={`Go To End User License Agreement Page`}
            className={({ isActive }) =>
              "header-link" + (isActive ? " active" : " ")
            }
            end
          >
            <ListItemButton
              sx={{
                minHeight: 48,
                justifyContent: "start",
                px: 2.5,
              }}
            >
              <ListItemIcon
                sx={{
                  minWidth: 0,
                }}
              >
                <Badge
                  badgeContent={0}
                  className="header-badge"
                ></Badge>
              </ListItemIcon>
              {endUserLicenseAgreement ? (
                <FontAwesomeIcon
                  icon={faSquareCheck}
                  color={"#e88f00"}
                  size="lg"
                  style={{ paddingRight: "10px" }}
                />
              ) : (
                <FontAwesomeIcon
                  icon={faSquare}
                  color={"#aaa"}
                  size="lg"
                  style={{ paddingRight: "10px" }}
                />
              )}
              <ListItemText
                primary={"End User License Agreement"}
                sx={{ color: "#002a4e" }}
              />
            </ListItemButton>
          </NavLink>
        </ListItem>
      </List>

        <FormGroup row sx={{justifyContent:'flex-end'}}>
            <Button
                variant="outlined"
                color="primary"
                type="submit"
                sx={{ mt: 2 }}
                disabled = {!(endUserLicenseAgreement)}
            >
                Next
            </Button>
        </FormGroup>
      </Card>
    </form>
  )
}